import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-iqac',
  templateUrl: './iqac.component.html',
  styleUrls: ['./iqac.component.scss']
})
export class IqacComponent implements OnInit {
    pageTitle: string;
    activeIndex: number | null = null;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {
        this.route.data.subscribe(params => {
            if (params && params.title) {
                this.pageTitle = params.title;
            }
        });
    }

    accordionItems = [
        {
            title: 'Certificate AISHE U-0176(2020-2021)',
            description: 'Certificate AISHE U-0176(2020-2021)',
            pdfFileName: 'certificate-aishe-u-20-21.pdf',
            downloadLabel: 'Certificate AISHE U-0176(2020-2021)',
            downloadUrl: 'assets/pdf/certificate-aishe-u-20-21.pdf',
            openExternally: false
        },
        {
            title: 'U-0176 Certificate DCF(2021-2022)',
            description: 'U-0176 Certificate DCF(2021-2022)',
            pdfFileName: 'U-0176-certificate-dcf-2021-2022.pdf',
            downloadLabel: 'U-0176 Certificate DCF(2021-2022)',
            downloadUrl: 'assets/pdf/U-0176-certificate-dcf-2021-2022.pdf',
            openExternally: false
        },
        {
            title: 'U-0176 Certificate DCF(2022-2023)',
            description: 'U-0176 Certificate DCF(2022-2023)',
            pdfFileName: 'u-0176-certificate-dcf-2022-2023.pdf',
            downloadLabel: 'U-0176 Certificate DCF(2022-2023)',
            downloadUrl: 'assets/pdf/u-0176-certificate-dcf-2022-2023.pdf',
            openExternally: false
        },
        {
            title: 'U-0176 Certificate DCF(2023-2024)',
            description: 'U-0176 Certificate DCF(2023-2024)',
            pdfFileName: 'u-0176-certificate-dcf-2023-2024.pdf',
            downloadLabel: 'U-0176 Certificate DCF(2023-2024)',
            downloadUrl: 'assets/pdf/u-0176-certificate-dcf-2023-2024.pdf',
            openExternally: false
        },
    ];
    pdfUrl: string | null = null;
    sanitizedPdfUrl: SafeResourceUrl | null = null;
    sections = [
        { heading: 'MANDATE', content: '<ul class="list-disc text-gray-500 p-4">\n' +
                '                  <li><span class="font-semibold">Quality Enhancement:</span> To create a system for consistent and conscious improvement in the performance of the university’s administrative and academic units.</li>\n' +
                '                  <li><span class="font-semibold">Stakeholder Engagement:</span> To facilitate the integration of the university\'s various stakeholders—students, faculty, staff, and external partners—in the quality assurance process.</li>\n' +
                '                  <li><span class="font-semibold">Best Practices:</span> To promote the adoption of best practices in teaching, learning, research, and governance.\n</li>\n' +
                '                  <li><span class="font-semibold">Feedback Mechanisms:</span> To establish robust feedback systems for continuous assessment and improvement.</li>\n' +
                '                </ul>' },
        { heading: 'FUNCTIONS IQAC', content: '<ul class="list-disc text-gray-500 p-4">\n' +
                '                  <li><span class="font-semibold">Curriculum Development:</span> Design and develop curricula that are perfectly aligned with modern tools and techniques to match industry standards.</li>\n' +
                '                  <li><span class="font-semibold">Academic Audits:</span> Regular and consistent audits to find the loopholes and enhance administrative and academic excellence.</li>\n' +
                '<li><span class="font-semibold">Professional Development:</span> Organizing meetups, seminars, workshops, guest lectures, and faculty training programs to enhance skills and networking opportunities.</li>\n' +
                '<li><span class="font-semibold">Research Promotion:</span> Cultivating research activities and facilitating the dissemination of research findings.</li>\n' +
                '<li><span class="font-semibold">Quality Documentation:</span> Maintaining comprehensive records of quality assurance activities and outcomes.</li>\n' +
                '                </ul>' },
    ];

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

    openPdfModal(event: Event, url: string) {
        event.preventDefault();
        if (url.startsWith('http') && !url.includes(window.location.hostname)) {
            window.open(url, '_blank');
            return;
        }

        this.pdfUrl = url;
        this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    closePdfModal(): void {
        this.pdfUrl = null;
        this.sanitizedPdfUrl = null;
    }

    formatDay(date: string): string {
        // Add your logic to format the day from the date
        return new Date(date).getDate().toString();
    }

    formatMonth(date: string): string {
        // Add your logic to format the month from the date
        return new Date(date).toLocaleString('default', {month: 'short'});
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

}
